import { MaintenanceWindowFormWebComponent } from './component/MaintenanceWindowFormWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOW_FORM } from '../../webcomponents.constants';

export { MaintenanceWindowFormWebComponent };

window.customElements.define(WEB_COMPONENT_MAINTENANCE_WINDOW_FORM, MaintenanceWindowFormWebComponent);
